import { render, staticRenderFns } from "./ahSelectClient.vue?vue&type=template&id=28674ea1&"
import script from "./ahSelectClient.vue?vue&type=script&lang=js&"
export * from "./ahSelectClient.vue?vue&type=script&lang=js&"
import style0 from "./ahSelectClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports